export default import.meta.glob('./*_controller.js', { eager: true })
